import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import ToastHandler from '../../components/toasthandler';
import Otp from './otp';

import {
  fetchSecurity,
  updatePassword,
} from '../../actions';

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pristine: true,
      password: '',
      newPassword: '',
      newPasswordConf: '',
      passwordSuccess: '',
    };
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value, pristine: false });
  }

  handleNewPasswordChange(event) {
    this.setState({ newPassword: event.target.value, pristine: false });
  }

  updatePassword(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { password, newPassword, newPasswordConf } = this.state;

    const type = 'updatePassword';

    const mismatchPassword = (newPassword && newPasswordConf) && (newPassword !== newPasswordConf);

    if (mismatchPassword) {
      return;
    }

    const data = {
      password,
      newPassword,
      type,
    };

    this.setState({ pristine: true });
    dispatch(updatePassword(data))
      .then((res) => {
        if (res.errors) {
          this.setState({ passwordSuccess: '' });
        }
        if (!res.errors) {
          this.setState({ password: '', newPassword: '', passwordSuccess: 'Password Updated' });
        }
      });
  }

  render() {
    const { user, errors, success } = this.props;
    const { pristine, password, newPassword, passwordSuccess, newPasswordConf } = this.state;

    let passMin;
    let passCaps;
    let passNum;
    let passSpec;

    if (newPassword.length >= 8) {
      passMin = true;
    }
    if (/[A-Z]/.test(newPassword)) {
      passCaps = true;
    }
    if (/[0-9]/.test(newPassword)) {
      passNum = true;
    }
    if (/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/.test(newPassword)) {
      passSpec = true;
    }

    const mismatchPassword = (newPassword && newPasswordConf) && (newPassword !== newPasswordConf);

    const completed = !pristine && password && newPassword && passMin && passCaps && passNum && passSpec && newPasswordConf && !mismatchPassword;

    const passRating = [passMin, passCaps, passNum, passSpec].filter(Boolean).length;

    return (
      <div className="grid-x">
        <ToastHandler errors={errors} success={success} />
        <div className="cell small-12 medium-12 large-12" style={{marginBottom: 20}}>
          <a className="backlink" href="/settings">
            <FontAwesomeIcon
              size="sm"
              icon={faChevronLeft}
            />
            &nbsp;
            Back to Settings
          </a>
        </div>
        <div className="cell panel v2 small-12 medium-12 large-12">
          <div className="panel-label">
            Security
          </div>
          <div className="grid-x align-middle">
            <div className="cell small-12 medium-12 large-12">
              <form onSubmit={this.updatePassword} id="newPass">
                <div className="grid-x">
                  <div className="cell small-12 medium-12 large-12">
                    <div className="grid-x">
                      <div className="cell small-12 medium-8 large-8">

                        <div className="grid-x group">
                          <div className="cell small-12 medium-6 large-6">
                            <div className="">Old Password</div>
                          </div>
                          <div className="cell small-12 medium-6 large-6">
                            <div className="">
                              <div className="input-wrapper">
                                <input className="input" type="password" name="password" placeholder="Old Password" value={password} onChange={this.handleChange} id="password" autoComplete="off" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="grid-x group">
                          <div className="cell small-12 medium-6 large-6">
                            <div className="">New Password</div>
                          </div>
                          <div className="cell small-12 medium-6 large-6">
                            <div className="">
                              <div className="input-wrapper">
                                <input className="input" type="password" name="newpassword" placeholder="New Password" value={newPassword} onChange={this.handleChange} id="newPassword" autoComplete="off" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="grid-x group">
                          <div className="cell small-12 medium-6 large-6" />
                          <div className="cell small-12 medium-6 large-6" >
                            <div className="p-scale-wrapper">
                              <div className={'p-scale rate-' + passRating}>
                                <div className="p-s-level" />
                                <div className="p-s-level" />
                                <div className="p-s-level" />
                                <div className="p-s-level" />
                                <div className="p-s-level" />
                              </div>
                              <div className="p-scale-text">
                                <span>Weak</span>
                                <span>Strong</span>
                              </div>
                              <div className="p-scale-wrapper show-mob">
                                <div>
                                  <div className={passMin ? 'p-s-req true' : 'p-s-req'}>
                                    <div className="p-s-check">
                                      <FontAwesomeIcon
                                        size="sm"
                                        icon={faCheck}
                                      />
                                    </div>
                                    <div className="p-s-check-label">at least 8 characters</div>
                                  </div>
                                  <div className={passCaps ? 'p-s-req true' : 'p-s-req'}>
                                    <div className="p-s-check">
                                      <FontAwesomeIcon
                                        size="sm"
                                        icon={faCheck}
                                      />
                                    </div>
                                    <div className="p-s-check-label">at least 1 capital letter</div>
                                  </div>
                                  <div className={passNum ? 'p-s-req true' : 'p-s-req'}>
                                    <div className="p-s-check">
                                      <FontAwesomeIcon
                                        size="sm"
                                        icon={faCheck}
                                      />
                                    </div>
                                    <div className="p-s-check-label">at least 1 number</div>
                                  </div>
                                  <div className={passSpec ? 'p-s-req true' : 'p-s-req'}>
                                    <div className="p-s-check">
                                      <FontAwesomeIcon
                                        size="sm"
                                        icon={faCheck}
                                      />
                                    </div>
                                    <div className="p-s-check-label">at least 1 special character (!@#$&*)</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="grid-x group">
                          <div className="cell small-12 medium-6 large-6">
                            <div className="">Confirm New Password</div>
                          </div>
                          <div className="cell small-12 medium-6 large-6">
                            <div className="">
                              <div className="input-wrapper">
                                <input
                                  className={mismatchPassword ? "input e-warn" : "input"}
                                  type="password" id="newPasswordConf" name="newPasswordConf" placeholder="Confirm New Password" value={newPasswordConf} onChange={this.handleChange} autoComplete="off" />
                                  {mismatchPassword ? (
                                    <p className="e-warn">New password fields must match</p>
                                  ) : null}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="grid-x group">
                          <div className="cell small-12 medium-6 large-6" />
                          <div className="cell small-12 medium-6 large-6">
                            <button className="vlt-btn wide" type="submit" form="newPass" disabled={!completed}>
                              <span>
                                Save
                              </span>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div className="cell small-12 medium-4 large-4 grid-y grid-padding-x">
                        <div className="cell small-12 medium-12 large-12">
                          <div className="">
                            <div className="p-scale-wrapper hide-mob">
                              <div>
                                <div className={passMin ? 'p-s-req true' : 'p-s-req'}>
                                  <div className="p-s-check">
                                    <FontAwesomeIcon
                                      size="sm"
                                      icon={faCheck}
                                    />
                                  </div>
                                  <div className="p-s-check-label">at least 8 characters</div>
                                </div>
                                <div className={passCaps ? 'p-s-req true' : 'p-s-req'}>
                                  <div className="p-s-check">
                                    <FontAwesomeIcon
                                      size="sm"
                                      icon={faCheck}
                                    />
                                  </div>
                                  <div className="p-s-check-label">at least 1 capital letter</div>
                                </div>
                                <div className={passNum ? 'p-s-req true' : 'p-s-req'}>
                                  <div className="p-s-check">
                                    <FontAwesomeIcon
                                      size="sm"
                                      icon={faCheck}
                                    />
                                  </div>
                                  <div className="p-s-check-label">at least 1 number</div>
                                </div>
                                <div className={passSpec ? 'p-s-req true' : 'p-s-req'}>
                                  <div className="p-s-check">
                                    <FontAwesomeIcon
                                      size="sm"
                                      icon={faCheck}
                                    />
                                  </div>
                                  <div className="p-s-check-label">at least 1 special character (!@#$&*)</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
});

export default connect(mapStateToProps)(ChangePassword);
